import React, { useCallback } from 'react'
import { InputNumber, Form } from 'antd'
import { WrappedFieldProps } from 'redux-form'
import { InputNumberProps } from 'antd/lib/input-number'
import { FormItemLabelProps } from 'antd/lib/form/FormItemLabel'

const { Item } = Form

type Props = WrappedFieldProps &
	InputNumberProps &
	FormItemLabelProps & {
		hideHelp?: boolean
	}

const InputNumberField = (props: Props) => {
	const {
		input,
		size,
		placeholder,
		label,
		required,
		prefix,
		disabled,
		style,
		meta: { error, touched },
		hideHelp,
		maxLength,
		className
	} = props

	const onChange = useCallback(
		(value: number | null) => {
			input.onChange(value)
		},
		[input]
	)

	return (
		<Item
			label={label}
			required={required}
			style={style}
			help={hideHelp ? undefined : touched && error}
			validateStatus={error && touched ? 'error' : undefined}
		>
			<InputNumber
				{...input}
				className={className}
				onChange={onChange}
				size={size || 'middle'}
				value={input.value}
				placeholder={placeholder}
				disabled={disabled}
				maxLength={maxLength}
				prefix={prefix}
				onBlur={() => {
					// NOTE: let the function empty
				}}
			/>
		</Item>
	)
}

export default React.memo(InputNumberField)
